import { render, staticRenderFns } from "./orderTatsReport.vue?vue&type=template&id=16b5fa52&scoped=true"
import script from "./orderTatsReport.vue?vue&type=script&lang=js"
export * from "./orderTatsReport.vue?vue&type=script&lang=js"
import style0 from "./orderTatsReport.vue?vue&type=style&index=0&id=16b5fa52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b5fa52",
  null
  
)

export default component.exports